import { Button } from "antd";
import React, { useState } from "react";
import ModalAddBus from "../modal/ModalAddBus";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonAddBusProps {
  tripId: string;
  /** Optional callback after adding bus */
  onSuccess?: () => void;
}

const ButtonAddBus: React.FC<ButtonAddBusProps> = (props: ButtonAddBusProps) => {
  const { tripId, onSuccess } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);  useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button size="large" onClick={showModal} className="font-medium" type="primary">
        Thêm xe
      </Button>
      <ModalAddBus
        tripId={tripId}
        onClose={handleCancel}
        visible={isModalOpen}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default ButtonAddBus;
